import SALARYRANGEBYROLEANDEXPERIENCE from 'data/mantechcar25/salary-by-role-and-experience.json';
import {
  StyledContainer,
  StyledTable,
  StyledValue
} from './AverageSalaryByRole.styled';

type Experience = '0-2' | '2-5' | '5-10' | '10-';
type SalaryBand = '20-30k' | '30-40k' | '40-50k' | '50-60k' | '60-80k' | '+80k';

type RoleRow = {
  role: string;
} & {
  [E in Experience]: Record<SalaryBand, number>;
};

const data: RoleRow[] = SALARYRANGEBYROLEANDEXPERIENCE as RoleRow[];

type AverageSalaryByRoleProps = {
  experience: Experience;
};

const AverageSalaryByRole: React.FC<AverageSalaryByRoleProps> = ({
  experience
}) => {
  const getClassColor = (val: number): string => {
    if (val === 0) return 'cell-color-1';
    if (val <= 5) return 'cell-color-2';
    if (val <= 9) return 'cell-color-3';
    if (val <= 14) return 'cell-color-4';
    if (val <= 19) return 'cell-color-5';
    if (val <= 24) return 'cell-color-6';
    if (val <= 29) return 'cell-color-7';
    return 'cell-color-8';
  };

  const ranges: SalaryBand[] = [
    '20-30k',
    '30-40k',
    '40-50k',
    '50-60k',
    '60-80k',
    '+80k'
  ];

  return (
    <StyledContainer>
      <StyledTable>
        <thead>
          <tr>
            <th></th>
            <th>€20-30K</th>
            <th>€31-40K</th>
            <th>€41-50K</th>
            <th>€51-60K</th>
            <th>€61-80K</th>
            <th>&gt;80K</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, i) => (
            <tr key={i}>
              <th>{row.role}</th>
              {ranges.map((range) => {
                const val = row[experience][range];
                return (
                  <td key={range}>
                    <StyledValue className={getClassColor(val)}>
                      {val.toFixed(1)}%
                    </StyledValue>
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </StyledTable>
    </StyledContainer>
  );
};

export default AverageSalaryByRole;
